import React, { memo, useCallback } from "react";
import { Button } from "@chakra-ui/react";
import colors from "app/colors";
import { MessageFragment, MessageThreadFragment } from "gql/graphql";
import { MessageSubType } from "modules/utils/Constants";
import { useOverlay } from "modules/providers/overlay-provider";
import { MODAL_TYPE } from "modules/providers/overlay-provider/overlay-provider";

interface IProps {
  messageThread: MessageThreadFragment;
  message: MessageFragment;
}

const AddPendingEmailUsersButton = ({ messageThread, message }: IProps) => {
  const { openModal } = useOverlay();

  const onClick = useCallback(() => {
    openModal({
      type: MODAL_TYPE.ADD_PENDING_EMAIL_USERS,
      id: messageThread.id,
      ids: messageThread.pendingEmailUserIdList,
    });
  }, [messageThread, openModal]);

  if (
    message.subType !== MessageSubType.NON_MEMBER_EMAIL_USERS_ADDED ||
    messageThread.pendingEmailUserIdList.length === 0
  ) {
    return null;
  }

  return (
    <Button
      variant="link"
      w="fit-content"
      fontSize="sm"
      color={colors.blue}
      fontWeight="bold"
      onClick={onClick}
    >
      +Click here to add emails
    </Button>
  );
};

export default memo(AddPendingEmailUsersButton);
